import { createEntityAdapter } from '@reduxjs/toolkit';
import { ProjectResponsePrivate } from '@tests/types';

export const projectsAdapter = createEntityAdapter<ProjectResponsePrivate<string>>();
